import React from "react";
import DateFormatting from "./DateFormatting";

function SessionHighlightUpcoming(props) {
    return (
        <SessionHighlight session={props.session} timezone={props.timezone} viewText={"View or edit"} onClick={props.onClick} type="upcoming" />
    )
}

function SessionHighlightUpcomingSmall(props) {
    return (
        <SessionHighlight session={props.session} size="small" timezone={props.timezone} viewText={"View or edit"} onClick={props.onClick} type="upcoming" />
    )
}

function SessionHighlightCompleted(props) {
    return (
        <SessionHighlight session={props.session} timezone={props.timezone} onClick={props.onClick} type="completed" />
    )
}

function SessionHighlightCompletedSmall(props) {
    return (
        <SessionHighlight session={props.session} size="small" timezone={props.timezone} onClick={props.onClick} type="completed" />
    )
}

function SessionHighlight(props) {
    const [date, time] = DateFormatting.parseISOStringToReadableDateAndTime(props.session.start_time, props.timezone);

    const small = props.size == "small"
    const sessionClassName = "session-highlight " + (props.type == "upcoming" ? "" : "faded") + (small ? "small " : "");

    return (
        <div className={sessionClassName} onClick={props.onClick}>
            <div className="session-highlight-text session-highlight-date">
                {date}
            </div>
            <div className="session-highlight-text session-highlight-time">
                {time}
            </div>
            <div className="session-highlight-text session-highlight-name">
                {props.session.first_name}
            </div>
            {!small &&
                <div className="session-highlight-text session-highlight-view ">
                    {props.viewText ? props.viewText : "View"}
                </div>
            }
        </div>
    )
}

function SessionHighlightUpcomingWithMission(props) {
    const [date, time] = DateFormatting.parseISOStringToReadableDateAndTime(props.session.start_time, props.timezone);

    const small = props.size == "small"
    const sessionClassName = "session-highlight mission ";

    return (
        <div className={sessionClassName} onClick={props.onClick}>
            <div className="session-highlight-text session-highlight-date">
                {date}
            </div>
            <div className="session-highlight-text session-highlight-time">
                {time}
            </div>
            <div className="session-highlight-text session-highlight-name">
                {props.session.first_name}
            </div>
            <div className="session-highlight-text session-highlight-name ">
                {props.session.mission_name}
            </div>

        </div>
    )
}




export {
    SessionHighlightUpcoming,
    SessionHighlightCompleted,
    SessionHighlight,
    SessionHighlightUpcomingSmall,
    SessionHighlightCompletedSmall,
    SessionHighlightUpcomingWithMission,
}